import { Tag } from '@pinchenterprisesnpm/friday-ui'

interface IRosterTagProps {
  value: number
  label: string
  handleRemoveTag: (value: number) => void
  isClosable?: boolean
}

export const RosterTag = ({
  value,
  label,
  handleRemoveTag,
  isClosable = true,
}: IRosterTagProps) => {
  return (
    <Tag
      key={value}
      type="primary"
      size="small"
      isClosable={isClosable}
      onClose={() => handleRemoveTag(value)}
    >
      {label}
    </Tag>
  )
}
